import React from 'react';

export const DisabilityRatingDescription = (
  <>
    <p>
      VA disability compensation (pay) provides monthly payments to Veterans
      with service-connected disabilities.
    </p>
    <p>
      You may get this benefit if we’ve concluded that you’re disabled because
      of an illness or injury caused&mdash;or made worse&mdash;by your
      active-duty service.
    </p>
  </>
);

export const DisabilityRatingLearnMore = (
  <>
    <p className="vads-u-margin-top--neg1p5">
      <va-link
        href="/disability/eligibility/"
        text="Learn more about eligibility for disability benefits"
        external
      />
    </p>
    <va-details label="Why we ask for this information">
      <p>We use this information to help us decide these 4 things:</p>
      <ul>
        <li>
          If you can use a shorter application, <strong>and</strong>
        </li>
        <li>
          What types of VA healthcare benefits you’re eligible for,{' '}
          <strong>and</strong>
        </li>
        <li>
          How soon we enroll you in VA healthcare, <strong>and</strong>
        </li>
        <li>
          How much (if anything) you’ll have to pay toward the cost of your care
        </li>
      </ul>
      <p>
        We give veterans with service-connected disabilities the highest
        priority.
      </p>
    </va-details>
  </>
);
